import FulfillmentQueue from './FulfillmentQueue';
export default function FulfillmentOnHold() {
  return (
    <FulfillmentQueue
      title="On Hold"
      statusFilter="on_hold"
      emptyMessage="No orders on hold"
      extraColumns={[
        {
          headerName: 'Hold Reason',
          field: 'on_hold_reason',
          width: 160,
          cellStyle: { display: 'flex', alignItems: 'center', color: 'var(--ink-secondary)' },
        },
      ]}
    />
  );
}
